import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=73c38cf4&scoped=true&"
import script from "./Card.vue?vue&type=script&lang=js&"
export * from "./Card.vue?vue&type=script&lang=js&"
import style0 from "./Card.vue?vue&type=style&index=0&id=73c38cf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c38cf4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73c38cf4')) {
      api.createRecord('73c38cf4', component.options)
    } else {
      api.reload('73c38cf4', component.options)
    }
    module.hot.accept("./Card.vue?vue&type=template&id=73c38cf4&scoped=true&", function () {
      api.rerender('73c38cf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Card.vue"
export default component.exports